export default __webpack_public_path__ + "static/media/city.a08700bd.png";